import { StyleSheet } from '@react-pdf/renderer';
import { cvConfig } from './cvConfig';

const { colors, fonts, spacing } = cvConfig;

/**
 * Estilos del CV usando react-pdf
 * Diseño profesional y elegante con paleta sobria
 */
export const cvStyles = StyleSheet.create({
  // Documento
  page: {
    backgroundColor: colors.background,
    padding: spacing.pageMargin,
    fontFamily: fonts.main,
    fontSize: fonts.size.body,
    color: colors.text,
  },

  // Header con fondo
  header: {
    marginBottom: spacing.sectionGap + 10,
    marginHorizontal: -spacing.pageMargin,
    marginTop: -spacing.pageMargin,
    paddingHorizontal: spacing.pageMargin,
    paddingTop: spacing.pageMargin,
    paddingBottom: 20,
    backgroundColor: colors.headerBg,
    borderBottom: `3 solid ${colors.primary}`,
  },
  name: {
    fontSize: fonts.size.h1,
    fontFamily: fonts.bold,
    color: colors.primary,
    marginBottom: 5,
    letterSpacing: 0.5,
  },
  title: {
    fontSize: fonts.size.h2 + 1,
    color: colors.secondary,
    marginBottom: 12,
  },
  contactInfo: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
    marginTop: 10,
  },
  contactItem: {
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: fonts.size.small,
    color: colors.textLight,
  },
  contactIcon: {
    marginRight: 4,
  },

  // Secciones con diseño elegante (gris oscuro + borde lateral)
  section: {
    marginBottom: spacing.sectionGap + 10,
  },
  sectionTitle: {
    fontSize: fonts.size.h2 + 1,
    fontFamily: fonts.bold,
    color: colors.background,
    backgroundColor: '#334155',  // Gris oscuro elegante (slate-700)
    marginBottom: 14,
    marginHorizontal: -10,
    paddingVertical: 8,
    paddingLeft: 15,
    paddingRight: 10,
    textTransform: 'uppercase',
    letterSpacing: 1.5,
    borderLeft: `4 solid ${colors.primary}`,
  },

  // About con fondo
  aboutText: {
    fontSize: fonts.size.body,
    lineHeight: spacing.lineHeight,
    color: colors.text,
    textAlign: 'justify',
    backgroundColor: colors.sectionBg,
    padding: 12,
    borderRadius: 3,
  },

  // Experiencia
  experienceItem: {
    marginBottom: spacing.itemGap + 6,
    paddingBottom: spacing.itemGap + 4,
    backgroundColor: colors.sectionBg,
    padding: 12,
    borderRadius: 3,
    borderLeft: `4 solid ${colors.primary}`,
  },
  experienceHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 6,
  },
  experienceTitle: {
    fontSize: fonts.size.h3,
    fontFamily: fonts.bold,
    color: colors.text,
  },
  experienceCompany: {
    fontSize: fonts.size.body + 2,
    fontFamily: fonts.bold,
    color: colors.primary,
    marginBottom: 4,
  },
  experienceDate: {
    fontSize: fonts.size.small,
    color: colors.textLight,
  },
  experienceDuration: {
    fontSize: fonts.size.small,
    color: colors.accent,
    fontFamily: fonts.bold,
    marginBottom: 8,
  },
  experienceDescription: {
    fontSize: fonts.size.body,
    color: colors.text,
    lineHeight: spacing.lineHeight,
    marginTop: 6,
  },
  experienceTechnologies: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 5,
    marginTop: 8,
  },
  technologyTag: {
    backgroundColor: colors.background,
    padding: '4 8',
    borderRadius: 3,
    fontSize: fonts.size.small,
    color: colors.primary,
    border: `1 solid ${colors.border}`,
  },

  // Proyectos
  projectItem: {
    marginBottom: spacing.itemGap + 6,
    paddingBottom: spacing.itemGap + 2,
    backgroundColor: colors.sectionBg,
    padding: 12,
    borderRadius: 3,
    borderLeft: `4 solid ${colors.accent}`,
  },
  projectHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
  },
  projectTitle: {
    fontSize: fonts.size.h3 + 1,
    fontFamily: fonts.bold,
    color: colors.text,
  },
  projectDate: {
    fontSize: fonts.size.small,
    color: colors.textLight,
  },
  projectDescription: {
    fontSize: fonts.size.body,
    color: colors.text,
    lineHeight: spacing.lineHeight,
    marginTop: 4,
    marginBottom: 6,
  },
  projectTechnologies: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 5,
    marginTop: 6,
  },

  // Skills
  skillsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  skillCategory: {
    marginBottom: 12,
    backgroundColor: colors.sectionBg,
    padding: 10,
    borderRadius: 3,
  },
  skillCategoryTitle: {
    fontSize: fonts.size.h3,
    fontFamily: fonts.bold,
    color: colors.primary,
    marginBottom: 6,
  },
  skillItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 3,
  },
  skillName: {
    fontSize: fonts.size.body,
    color: colors.text,
    flex: 1,
  },
  skillLevel: {
    fontSize: fonts.size.small,
    color: colors.textLight,
  },
  skillBar: {
    width: 60,
    height: 4,
    backgroundColor: colors.border,
    borderRadius: 2,
    marginLeft: 8,
    position: 'relative',
  },
  skillBarFill: {
    height: '100%',
    backgroundColor: colors.primary,
    borderRadius: 2,
  },

  // Footer
  footer: {
    position: 'absolute',
    bottom: 20,
    left: spacing.pageMargin,
    right: spacing.pageMargin,
    fontSize: fonts.size.small,
    color: colors.textLight,
    textAlign: 'center',
    paddingTop: 10,
    borderTop: `1 solid ${colors.border}`,
  },

  // Utilidades
  row: {
    flexDirection: 'row',
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  alignCenter: {
    alignItems: 'center',
  },
  mb5: {
    marginBottom: 5,
  },
  mb10: {
    marginBottom: 10,
  },
  link: {
    color: colors.primary,
    textDecoration: 'none',
  },
});
